import { Dispatch, SetStateAction } from 'react';
import { useQuery } from 'react-query';

import {
  CalendarEvent,
  EventsByMonth,
  eventsKey,
  getApplicantCalendarEventsRoute,
  InterviewBlock,
} from '@features/events';
import axiosInstance from '@server/axiosInstance';

type useGetApplicantEventsData = {
  status: number;
  message: string;
  object: InterviewBlock[];
};

type useGetApplicantEventsProps = {
  setEvents: Dispatch<SetStateAction<EventsByMonth | []>>;
  year: string;
  month: string;
};

export const useGetApplicantEvents = ({
  setEvents,
  year,
  month,
}: useGetApplicantEventsProps) => {
  useQuery<useGetApplicantEventsData>({
    queryKey: [eventsKey, month, year],
    queryFn: () => {
      const params = new URLSearchParams();
      params.append('m', String(month));
      params.append('y', String(year));

      return axiosInstance
        .get(getApplicantCalendarEventsRoute, { params })
        .then((res) => res.data);
    },
    refetchOnWindowFocus: false,
    onSuccess: (data) => {

      if (data.status === 200) {
        const formattedBlockInvite: CalendarEvent[] =
          data.object.block_invites
            .map((block: InterviewBlock) => ({
              start: block?.block.dt_start_time,
              end:  block?.block.dt_end_time,
              slotStart: block?.slot ? block?.slot.slot_start_time : block?.block.dt_start_time,
              slotEnd: block?.slot ? block?.slot.slot_end_time : block?.block.dt_end_time,
              title: 'Open Interviews',
              type:'block',
              // title: `Interview for ${block.application.position} at ${block.company.s_name}`,
              event: { ...block?.block,type:'block', application: block?.application, block_start_date:block?.block.dt_start_time, block_end_date:block?.block.dt_end_time, dt_start_time: block?.slot ? block?.slot.slot_start_time : block?.block.dt_start_time, dt_end_time:block?.slot ? block?.slot.slot_end_time : block?.block.dt_end_time},
            })) ?? [];

        // Filter and format events
        const formattedEvents: CalendarEvent[] =
          data?.object?.events
            .map((block: InterviewBlock) => ({
              start: block?.interview.dt_start_time,
              end: block?.interview.dt_end_time,
              title: block?.interview.s_label,
              event: {...block.interview, type:'event',},
              type:'event',
            })) ?? [];

        setEvents([...formattedEvents, ...formattedBlockInvite]);
      } else if (data.status === 404) {
        setEvents([]);
      }

    },
  });
};
